export default "__VITE_ASSET__CtuWGVeq__"